import { apiInstance } from "../utils/_apiInstance";

export interface SearchInfo {
  _id: string;
  nome: string;
  tipo: string;
  data: string;
}

export interface SavedSearch {
  success: boolean;
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  items: SearchInfo[];
}

export const getSavedSearches = async (
  page: number = 1,
  limit: number = 10,
  sort?: string,
  order?: string,
) => {
  const params: Record<string, any> = { page, limit };
  if (sort) params.sort = sort;
  if (order) params.order = order;

  const response = await apiInstance.get<SavedSearch>("pesquisas-salvas", {
    params,
  });
  return response.data;
};
